import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from '@mui/material';
import { Table, Spin } from 'antd';

interface Props {
  open: boolean;
  title: string | undefined;
  loading: boolean;
  onClose: () => void;
  columns: any;
  dataSource: any[];
  customHeader?: React.ReactNode;
}

export const DetailsModal: React.FC<Props> = ({ open, title, loading, onClose, columns, dataSource, customHeader }) => {
  return (
    <Dialog maxWidth="lg" fullWidth open={open} onClose={onClose} sx={{ '& .MuiDialog-paper': { borderRadius: 2 } }}>
      <DialogTitle sx={{ backgroundColor: 'var(--primaryColor, #116599)', color: '#fff', fontWeight: 'bold', py: 1.5 }}>
        {title}
      </DialogTitle>
      <DialogContent dividers sx={{ backgroundColor: 'var(--grayWhite, #f1f1f1)', minHeight: '250px' }}>
        {customHeader && <Box sx={{ mb: 1 }}>{customHeader}</Box>}
        <Spin spinning={loading} tip="Chargement...">
          <Table size="small" bordered pagination={false} scroll={{ y: 300, x: 'max-content' }} columns={columns} dataSource={dataSource} />
        </Spin>
      </DialogContent>
      <DialogActions sx={{ backgroundColor: '#fafafa', py: 0.5 }}>
        <Button onClick={onClose} variant="outlined" color="inherit" size="small">Fermer</Button>
      </DialogActions>
    </Dialog>
  );
};